import { z } from 'zod';
/** Поиск (фаза 7.1, ADR-014): по всем спейсам пользователя или внутри проекта. */
export const searchQuerySchema = z.object({
    q: z.string().trim().min(1).max(200),
    /** Только этот проект (⌘K внутри проекта ищет сначала здесь). */
    projectId: z.uuid().optional(),
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
/** Не больше 8 слов: длинный запрос не делает поиск точнее, а запрос к индексу — дороже. */
const MAX_TERMS = 8;
/**
 * Слова запроса → `to_tsquery`: все слова обязательны, последнее — префиксом (поиск по мере набора).
 * Из слов остаются только буквы и цифры, поэтому операторы tsquery из пользовательского ввода не проходят.
 * Пустая строка — в запросе нет слов (только знаки).
 */
export function tsQueryText(q) {
    const terms = (q
        .toLocaleLowerCase('ru')
        .replace(/ё/g, 'е')
        .match(/[\p{L}\p{N}]+/gu) ?? []).slice(0, MAX_TERMS);
    return terms.map((t, i) => (i === terms.length - 1 ? `${t}:*` : t)).join(' & ');
}
//# sourceMappingURL=search.js.map